import { useLocation, useSearchParams } from 'react-router-dom';

export const useIsSurveyPreview = (): boolean => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  return searchParams.get('preview') === 'true' || location.pathname.startsWith('/survey-preview/');
};
